import { Exact } from "src/generated/graphql";
import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Query } from "apollo-angular";

export type GetScoreLevelQueryVariables = Exact<{ [key: string]: never }>;

export type GetScoreLevelQuery = {
  getScoreLevels: [
    {
      id: number;
      levelName: string;
    }
  ];
};

export const GetScoreLevelDocument = gql`
  query GetScoreLevels {
    getScoreLevels {
      id
      levelName
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetScoreLevelsGQL extends Query<GetScoreLevelQuery, GetScoreLevelQueryVariables> {
  document = GetScoreLevelDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
